
export default {
  'm':{
    'collect_cards_slogan':'Recoge cartas para ganar millones de diamantes',
    'participate_event':'Eventos de matriculación',
    'event_rule_title':'Reglas de actividad',
    'event_rule_desc':'Durante el período del evento, cada 300 diamantes recargados se puede dibujar una vez, el sorteo 100% obtener cualquier Carta, tienen cinco Cartas se pueden intercambiar por Carta de rey, los usuarios que tienen Cartas de rey, con el número de Cartas de rey propiedad dividir el gran premio, la recompensa se emitirá automáticamente al final del evento.',
    'draws_diamonds_num':'Número de diamantes recargados',
    'available_draws':'Mis sorteos disponibles',
    'sel_card':'Haga clic para seleccionar una Catra',
    'gift_id':'Enviar ID',
    'synthesis':'Sintelizar',
    'gongxi_tip':'ID {msg_ss}**** Catra Rey Sintética',
    'divide_countdown':'Hasta que se reparta el premio de la Carta del Rey',
    'congra_baron':'Enhorabuena¡has conseguido Carta del Barón!',
    'congra_viscount':'Enhorabuena¡has conseguido Carta vizcondesa!',
    'congra_earl':'Enhorabuena¡has conseguido Carta Piaget!',
    'congra_marquis':'Enhorabuena¡has conseguido Carta Marquis!',
    'congra_duke':'Enhorabuena¡has conseguido Carta del Duque!',
    'congra_king':'Enhorabuena. ¡Has recibido la valiosa Carta del Rey!',
    'reward_king':'Recompensa la carta del Rey',
    'click_send_friend':'Haga clic en la tarjeta para regalarla a un amigo ~',
    'reward_tip':'El premio final es la aportación de todos los usuarios participantes',
    'participated':'Has participado evento',
    'event_finish':'El evento está cerrado',
    'recipient_not':'El receptor no existe',
    'baoming_canjia':'Por favor, inscríbase primero y luego participe en el evento.',
    'card_not_enough':'Número insuficiente de cartas',
    'not_draws':'Se han quedado sin sorteos',
    'sel_a_card':'Seleccione la tarjeta que desea enviar',
    'send_success':'Entrega exitosa de la tarjeta',
    'not_this_card':'No existe tal tarjeta',
    'reward_delay_notice':'El evento es tan caliente que su recompensa llegará más tarde',
    'friend_send_nan':'{msg_ss} le ha enviado una Carta del Barón',
    'friend_send_zi':'{msg_ss} le ha enviado una Carta vizcondesa',
    'friend_send_bo':'{msg_ss} le ha enviado una Carta Piaget',
    'friend_send_hou':'{msg_ss} le ha enviado una Carta Marquis',
    'friend_send_gong':'{msg_ss} le ha enviado una Carta del Duque',
  },
}



// WEBPACK FOOTER //
// ./src/i18n/lang/es.js